import { faqData } from '@/mocks/home';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于51吃瓜网，你想知道的都在这里</p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <div className="p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xs font-bold mt-0.5">Q</span>
                  <div className="flex-1">
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2">{item.question}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}